import styled from "styled-components";

import { StyledGeneralTabTable } from "@pages/Patients/Laboratory/components/GeneralTab/GeneralTab.styled";

import { rem } from "@styles/Utilities.styled";


export const StyledGeneralTab = styled(StyledGeneralTabTable)`
  tr {
    height: ${rem(60)};
    /* height: auto; */
  }
  th,
  td {
    padding: 0.8em 5em 0.8em 0;

    &:first-child {
      padding-right: 0.5em;
    }
  }
`;
